import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { del, get, post, put } from "../../helpers/api_helper"
import { APIServerIP } from "../../../src/helpers/Sats_api_helper"

const initialVenueState = {
  TicketVenueList: [],
  volunteers: [],
  TicketBookedDetails: [],
  TicketVenueisSuccessfully: false,
  isUserEdit: false,
  scannedUser: null,
  scannedUserStatus: null,
  scannerStatusMessage: null,
  paymentList: [],
  paymentIsSuccessfully: false,
}

const TicketVenueSlice = createSlice({
  name: "EventTicketVenue",
  initialState: initialVenueState,
  reducers: {
    setTicketVenueList: (state, action) => {
      state.TicketVenueList = action.payload
    },
    setVenueSuccessfullyAdded: (state, action) => {
      state.TicketVenueisSuccessfully = true
    },
    setUserEdit: (state, action) => {
      state.isUserEdit = true
    },
    setvolunteerList: (state, action) => {
      state.volunteers = action.payload
    },
    setTicketBookedList: (state, action) => {
      state.TicketBookedDetails = action.payload
      state.TicketVenueisSuccessfully = true
    },
    resetVenue: (state, action) => {
      state.TicketVenueisSuccessfully = false
      state.isUserEdit = false
    },
    ticketScanned: (state, action) => {
      state.scannedUser = action.payload.data
      state.scannedUserStatus = action.payload.message_code
      state.scannerStatusMessage = action.payload.message
    },
    resetScannedData: (state, action) => {
      state.scannedUser = null
      state.scannedUserStatus = null
      state.scannerStatusMessage = null
    },
    setPaymentList: (state, action) => {
      state.paymentList = action.payload
    },
    setPaymentSuccessfully: state => {
      state.paymentIsSuccessfully = true
    },
    resetPaymentState: state => {
      state.paymentIsSuccessfully = false
    },
  },
})

 
export const createTicketVenue = values => {
  return async dispatch => {
    try {
      const responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/create-ticket-event-venue`,
        values
      )

      if (responseData.response_code === 200) {
        dispatch(setVenueSuccessfullyAdded())
      }

      // 🔴 IMPORTANT: return response so component receives _id
      return { payload: responseData }

    } catch (error) {
      console.log(error)
      throw error
    }
  }
}
 

export const updateVenue = values => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/update-ticket-event-venue`,
        values
      )
      // console.log("Venue user", responseData)
      if (responseData.response_code === 200) {
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}

export const deleteVenue = id => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/delete-ticket-event-venue`,
        id
      )

      if (responseData.response_code === 200) {
        console.log("Venue user", responseData)
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}
export const activeInactiveVenue = data => {
  return async dispatch => {
    try {
      dispatch(resetVenue())
      const responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/SetactiveInactive-manage-ticket-event-venue`,
        data
      )

      if (responseData.response_code === 200) {
        // console.log("active user", responseData)
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("try error", error)
    }
  }
}

export const editUser = data => {
  return async dispatch => {
    try {
      localStorage.setItem("editUser", JSON.stringify(data))
      dispatch(setUserEdit())
    } catch (err) {
      console.log("editUsererr", err)
    }
  }
}

export const fetchVenue = id => {
  // console.log(id)
  return async dispatch => {
    // dispatch(resetVenue())
    try {
      console.log("Sending Event ID:", id)
      let responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/fetch-ticket-event-venues`,
        { master_event_id: id }
      )
      console.log("active get users", responseData)
      if (responseData.response_code === 200) {
        dispatch(setTicketVenueList(responseData.data))
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}
// updating venue draft /publish status
export const updateVenueStatus = values => {
  return async dispatch => {
    try {
      const responseData = await post(
        `${APIServerIP}manage-ticket-event-venue/create-ticket-event-venue`,
        values
      )

      if (responseData.response_code === 200) {
        dispatch(setVenueSuccessfullyAdded())
      }
    } catch (error) {
      console.log("Status update error", error)
    }
  }
}

export const TicketBookedHistory = id => {
  // console.log(id)
  return async dispatch => {
    dispatch(resetVenue())
    try {
      let responseData = await post(
        `${APIServerIP}manage-booking-user/fetch-venue-ticket-booking-user`,
        { master_venue_id: id }
      )
      console.log("TicketBookedHistory", responseData)
      if (responseData.response_code === 200) {
        dispatch(setTicketBookedList(responseData.data))
      }
    } catch (error) {
      console.log("try error fetch", error)
    }
  }
}

export const volunteerList = data => {
  return async dispatch => {
    try {
      let responseData = await get(`${APIServerIP}`, data)
      // console.log("volunteers get users", responseData)
      if (responseData.response_code === 200) {
        dispatch(setvolunteerList(responseData.data))
      }
    } catch (err) {
      console.log("try error volunteers", err)
    }
  }
}

export const scanningData = data => {
  return async dispatch => {
    try {
      let responseData = await post(
        `${APIServerIP}manage-booking-user/scan-ticket`,
        data
      )
      console.log("responseData", responseData)
      // if (responseData.response_code === 200) {
      dispatch(ticketScanned(responseData))
      // }
    } catch (error) {
      console.log("error", error)
    }
  }
}

export const fetchPayments = () => {
  return async dispatch => {
    dispatch(resetPaymentState())
    try {
      const response = await get(
        `${APIServerIP}manage-booking-user/fetch-payment-types`
      )
      if (response.response_code === 200) {
        dispatch(setPaymentList(response.data))
      }
    } catch (error) {
      console.error("Failed to fetch payments:", error)
    }
  }
}

// ---------------- Add Payment ----------------
export const addPayment = (paymentData, envKeys) => {
  return async dispatch => {

    dispatch(resetPaymentState())

    try {

      // 1️⃣ Create payment in DB
      const response = await post(
        `${APIServerIP}manage-booking-user/add-payment-type`,
        paymentData
      )

      if (response.response_code === 200) {

        dispatch(setPaymentSuccessfully())

        // 2️⃣ Save keys in .env
        if (
          envKeys?.paypalClientId ||
          envKeys?.paypalSecret ||
          envKeys?.stripePublishable ||
          envKeys?.stripeSecret
        ) {

          await post(
            `${APIServerIP}manage-ticket-event-venue/admin/update-payment-keys`,
            envKeys
          )

        }

        // 3️⃣ Refresh payment list
        const payments = await get(
          `${APIServerIP}manage-booking-user/fetch-payment-types`
        )

        if (payments.response_code === 200) {
          dispatch(setPaymentList(payments.data))
        }

      }

      return response

    } catch (error) {

      console.error("Failed to add payment:", error)
      throw error

    }

  }
}

// ---------------- Update Payment ----------------
export const updatePayment = (paymentData, envKeys) => {
  return async dispatch => {
    dispatch(resetPaymentState())

    try {
      // 1️⃣ Update DB
      const response = await put(
        `${APIServerIP}manage-booking-user/update-payment-type`,
        paymentData
      )

      if (response.response_code === 200) {
        dispatch(setPaymentSuccessfully())

        // 2️⃣ Update .env directly
        if (
          envKeys?.paypalClientId ||
          envKeys?.paypalSecret ||
          envKeys?.stripePublishable ||
          envKeys?.stripeSecret
        ) {
          await post(
            `${APIServerIP}manage-ticket-event-venue/admin/update-payment-keys`,
            envKeys
          )
        }
      }

      return response
    } catch (error) {
      console.error("Failed to update payment:", error)
      throw error
    }
  }
}

// ---------------- Delete Payment ----------------
export const deletePayment = paymentId => {
  return async dispatch => {
    dispatch(resetPaymentState())

    try {

      const response = await del(
        `${APIServerIP}manage-booking-user/delete-payment-type/${paymentId}`
      )

      if (response.response_code === 200) {
        dispatch(setPaymentSuccessfully())
      }

      return response

    } catch (error) {
      console.error("Failed to delete payment:", error)
      throw error
    }
  }
}

export const {
  setTicketVenueList,
  setVenueSuccessfullyAdded,
  setUserEdit,
  setTicketBookedList,
  resetVenue,
  setvolunteerList,
  ticketScanned,
  resetScannedData,
  setPaymentList,
  setPaymentSuccessfully,
  resetPaymentState,
} = TicketVenueSlice.actions

export default TicketVenueSlice.reducer
